import { Select, Dropzone, DateInput } from '@ui/src';
import { DocumentCreateTypes } from './types';
import UploadedFile from './parts/uploaded-file';

import cn from './styles.module.css';

const DocumentCreate = ({
  onUpload,
  onSelect,
  selectedGroup,
  dropZoneInputRef,
  onDelete,
  uploadInputRef,
  fileUploadInProgress,
  uploadedFiles,
  uploadedFilesErrors,
  setExpirationDate,
  expirationDate,
  allowedCategories,
  setUploadedFiles,
  attachedDocumentsErrors,
  attachedFiles,
  uploadedDocumentsErrors,
}: DocumentCreateTypes) => (
  <div className={cn.documentCreate}>
    <div className={cn.fileInputWrapper}>
      <div className={cn.inputTitle}>File</div>
      <label htmlFor="upload-input" className={cn.fileInputLabel}>
        <input
          type="file"
          id="upload-file"
          className={cn.fileInput}
          onChange={(e) => onUpload(e.target.files as FileList)}
          ref={uploadInputRef}
          multiple
        />
        <div className={cn.fileInputVisual}>Select document on your PC</div>
      </label>
    </div>
    <Dropzone
      onUpload={onUpload}
      fileUploadInProgress={fileUploadInProgress}
      inputRef={dropZoneInputRef}
      dropzoneText="or drop file here"
      dropzoneClassName={cn.documentDropZone}
      dropzoneTextClassName={cn.documentDropZoneText}
    />
    {uploadedFiles &&
      uploadedFiles.length > 0 &&
      uploadedFiles?.map((item) => (
        <UploadedFile
          key={item.id}
          item={item}
          items={uploadedFiles}
          onDelete={onDelete}
          setUploadedFiles={setUploadedFiles}
          error={
            attachedDocumentsErrors ? attachedDocumentsErrors[item.id] : ''
          }
          attachedFiles={attachedFiles}
        />
      ))}
    {uploadedDocumentsErrors && uploadedDocumentsErrors?.length > 0 && (
      <ul className={cn.uploadedDocumentsErrors}>
        {uploadedDocumentsErrors?.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${item.name}-${index}`}>
            - The document <strong>{item.name}</strong> was not uploaded.
            <br />
            <span>
              <strong>Reason:</strong> {item.error}
            </span>
          </li>
        ))}
      </ul>
    )}
    {uploadedFilesErrors && uploadedFilesErrors.length > 0 && (
      <ul className={cn.uploadedFilesErrors}>
        {uploadedFilesErrors.map((item) => (
          <li key={item}>{`- ${item}`}</li>
        ))}
      </ul>
    )}
    <div className={cn.selectWrapper}>
      <div className={cn.inputTitle}>Group</div>
      <Select
        list={allowedCategories?.map((item) => ({
          name: item.name,
          value: item.id,
        }))}
        selectWrapperClassName={cn.documentGroupSelect}
        placeholder="Select document group"
        name="selectedGroup"
        value={selectedGroup}
        onChange={(e) => onSelect(e.target.value as string)}
      />
    </div>
    <div className={cn.selectWrapper}>
      <div className={cn.inputTitle}>Expiration Date</div>
      <DateInput
        value={expirationDate?.toISOString() || ''}
        onChange={(date) => setExpirationDate(date)}
        placeholder="Select Expiration Date"
        className={cn.expirationDate}
        fullWidth
        withoutCustomSelector
      />
    </div>
  </div>
);

export default DocumentCreate;
